// export const API_URL = "http://0.0.0.0:5000/"
export const API_URL = "https://api.cythero.com/"
export const STATIC_URL = "https://static.cythero.com/"

export const app_analytics = {
    1 : [18, 23],
    7: [19, 24]
}